import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import usePageMetadata from '../utils/usePageMetadata';
import './Auth.css';

const Demo = () => {
  usePageMetadata({
    title: 'Demo | The Ad Shop',
    description: 'Try The Ad Shop with full demo data. Explore all dashboards and features with sample analytics data.',
    canonicalUrl: 'https://theadshop.co/demo',
    meta: [
      { property: 'og:title', content: 'Demo | The Ad Shop' },
      {
        property: 'og:description',
        content: 'Try The Ad Shop with full demo data. Explore all dashboards and features.',
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://theadshop.co/demo' },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:title', content: 'Demo | The Ad Shop' },
      {
        name: 'twitter:description',
        content: 'Try The Ad Shop with full demo data.',
      },
    ],
  });

  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleDemoLogin = async () => {
      try {
        setLoading(true);
        setError('');
        
        // Call demo login endpoint
        const response = await axios.get('/api/demo/login');
        
        // Log in the user with the demo credentials
        login(response.data.user, response.data.token);
        
        // Redirect to dashboard
        navigate('/dashboard');
      } catch (err) {
        console.error('Demo login error:', err);
        setError(err.response?.data?.message || 'Failed to access demo. Please try again.');
        setLoading(false);
      }
    };

    handleDemoLogin();
  }, [login, navigate]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        {loading ? (
          <div className="auth-loading">
            <div className="spinner"></div>
            <h1>Loading Demo...</h1>
            <p>Setting up your demo account with full sample data...</p>
          </div>
        ) : error ? (
          <div className="auth-error">
            <h1>Demo Access Error</h1>
            <p>{error}</p>
            <button 
              onClick={() => window.location.reload()} 
              className="btn btn-primary"
            >
              Try Again
            </button>
            <p style={{ marginTop: '1rem' }}>
              <a href="/login">Go to Login</a> or <a href="/">Return Home</a>
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Demo;

